module.exports = __webpack_public_path__ + "static/media/notify.b0e60da7.svg";